(function(){
  if (window.__tbHover) return; window.__tbHover = 1;
  var desk = window.matchMedia('(hover: hover) and (min-width: 990px)');
  function card(t){return t && t.closest ? t.closest('.card-wrapper') : null;}
  function alt(w){return w ? w.querySelector('.media--hover-effect > :nth-child(2)') : null;}
  function vid(w){return w ? w.querySelector('video.tb-hover-video') : null;}
  /* Shopify serves the product video as 1080p (7.2 Mbps); cards only need 480p/720p */
  function lite(v, q){
    if (!v || v._tbQ) return; v._tbQ = 1;
    var s = v.querySelector('source'); if (!s) return;
    var full = s.getAttribute('src'), nu = full.replace(/\.HD-1080p-[\d.]+Mbps-/, q === 480 ? '.SD-480p-1.5Mbps-' : '.HD-720p-4.5Mbps-');
    if (nu === full) return;
    s.addEventListener('error', function(){ if (s.getAttribute('src') !== full) { s.src = full; v.load(); var p = v.play(); if (p && p.catch) p.catch(function(){}); } });
    s.src = nu; v.load();
  }
  function play(v){ if(!v) return; lite(v, desk.matches ? 720 : 480); clearTimeout(v._tbT); v.muted = true; v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function(){}); }
  function stop(v, d){ if(!v) return; clearTimeout(v._tbT); v._tbT = setTimeout(function(){ v.pause(); try { v.currentTime = 0; } catch(_){} }, d); }

  /* ---------- desktop: hover ---------- */
  document.addEventListener('mouseover', function(e){
    if (!desk.matches) return;
    var w = card(e.target); if (!w || (e.relatedTarget && w.contains(e.relatedTarget))) return;
    var v = vid(w); if (!v) return;
    v.style.opacity = '1'; play(v);
  });
  document.addEventListener('mouseout', function(e){
    if (!desk.matches) return;
    var w = card(e.target); if (!w || (e.relatedTarget && w.contains(e.relatedTarget))) return;
    var v = vid(w); if (!v) return;
    v.style.opacity = '0'; stop(v, 500);
  });

  /* ---------- mobile: swipe ---------- */
  var css = document.createElement('style');
  css.textContent =
    '@media (hover: none), (max-width: 989px){' +
    '.tb-swipe .media--hover-effect > :nth-child(2){transition:opacity .45s ease}' +
    '.tb-swipe .media--hover-effect > img:first-child{transition:opacity .45s ease}' +
    '.tb-swipe.tb-alt .media--hover-effect > img:first-child{opacity:0 !important}' +
    '.tb-swipe.tb-alt .media--hover-effect > :nth-child(2){opacity:1 !important}' +
    '.tb-swipe .card__inner,.tb-swipe .full-unstyled-link{touch-action:pan-y pinch-zoom}' +
    '.tb-dots{position:absolute;left:50%;bottom:10px;transform:translateX(-50%);display:flex;align-items:center;gap:6px;z-index:3;pointer-events:none}' +
    '.tb-dots i{display:block;width:6px;height:6px;border-radius:50%;background:rgba(255,255,255,.5);box-shadow:0 0 3px rgba(0,0,0,.35);transition:background .3s}' +
    '.tb-dots i.v{width:0;height:0;border-radius:0;background:none;box-shadow:none;border-style:solid;border-width:4px 0 4px 7px;border-color:transparent transparent transparent rgba(255,255,255,.55);filter:drop-shadow(0 0 2px rgba(0,0,0,.4))}' +
    '.tb-swipe:not(.tb-alt) .tb-dots i:first-child,.tb-swipe.tb-alt .tb-dots i:last-child:not(.v){background:#fff}' +
    '.tb-swipe.tb-alt .tb-dots i.v{border-left-color:#fff}' +
    '}' +
    '@media (hover: hover) and (min-width: 990px){.tb-dots{display:none}}';
  document.head.appendChild(css);

  function inSlider(w){
    var s = w.closest('.slider, .slider--mobile, slider-component ul');
    return !!(s && s.scrollWidth > s.clientWidth + 4);
  }
  /* mobile: buffer the video while the card is on screen, so a swipe plays instantly */
  function warm(w){
    var v = vid(w); if (!v || v._tbWarm) return; v._tbWarm = 1;
    lite(v, 480);
    v.muted = true; v.preload = 'auto';
    var p = v.play();
    var hold = function(){ if (!w.classList.contains('tb-alt')) v.pause(); };
    if (p && p.then) p.then(hold, function(){ try { v.load(); } catch(_){} }); else hold();
  }
  var wio = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(en){ if (en.isIntersecting && !desk.matches) { var w = card(en.target); if (w) warm(w); wio.unobserve(en.target); } });
  }, {rootMargin: '200px 0px'}) : null;
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(en){ if (!en.isIntersecting) { var w = card(en.target); if (w && w.classList.contains('tb-alt')) { w.classList.remove('tb-alt'); stop(vid(w), 450); } } });
  }, {threshold: 0.25}) : null;

  function init(root){
    (root || document).querySelectorAll('.card-wrapper').forEach(function(w){
      if (w.__tbInit) return; w.__tbInit = 1;
      if (!alt(w)) return;
      w.classList.add('tb-swipe');
      var inner = w.querySelector('.card__inner');
      if (inner && !inner.querySelector('.tb-dots')) {
        var d = document.createElement('span'); d.className = 'tb-dots'; d.setAttribute('aria-hidden', 'true');
        d.innerHTML = '<i></i><i' + (vid(w) ? ' class="v"' : '') + '></i>';
        inner.appendChild(d);
      }
      if (io && inner) io.observe(inner);
      if (wio && inner && vid(w)) wio.observe(inner);
    });
  }
  function show(w, on){
    if (on === w.classList.contains('tb-alt')) return;
    w.classList.toggle('tb-alt', on);
    var v = vid(w);
    if (on) play(v); else stop(v, 450);
    if (on) document.querySelectorAll('.card-wrapper.tb-alt').forEach(function(o){ if (o !== w) { o.classList.remove('tb-alt'); stop(vid(o), 450); } });
  }

  var sx = 0, sy = 0, sw = null, swiped = 0;
  document.addEventListener('touchstart', function(e){
    var w = card(e.target); sw = null;
    if (!w || desk.matches || e.touches.length > 1) return;
    if (!w.__tbInit) init(w.parentNode);
    if (!w.classList.contains('tb-swipe') || inSlider(w)) return;
    sw = w; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    var v = vid(w); if (v) { warm(w); if (!w.classList.contains('tb-alt')) { clearTimeout(v._tbT); var pp = v.play(); if (pp && pp.catch) pp.catch(function(){}); } }
  }, {passive: true});
  document.addEventListener('touchend', function(e){
    if (!sw) return;
    var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
    if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.3) {
      show(sw, dx < 0);
      swiped = Date.now();
    } else if (!sw.classList.contains('tb-alt')) { var v = vid(sw); if (v) v.pause(); }
    sw = null;
  }, {passive: true});
  document.addEventListener('touchcancel', function(){
    if (sw && !sw.classList.contains('tb-alt')) { var v = vid(sw); if (v) v.pause(); }
    sw = null;
  }, {passive: true});
  document.addEventListener('click', function(e){
    if (Date.now() - swiped < 450 && card(e.target)) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  function boot(){
    init();
    if ('MutationObserver' in window) {
      new MutationObserver(function(ms){ for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { init(); break; } })
        .observe(document.body, {childList: true, subtree: true});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
